<template>
  <div class="row mx-0 pb-2 pt-3 bg-grey position-relative" >
    <div  class="col-auto position-absolute top-50 start-50 translate-middle" v-if="storageStatus !== 'ready'">
      <div class="spinner-border spinner-border-sm" role="status" >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="col-12 p-0" :class="{'opacity-25': storageStatus !== 'ready'}">
      <div class="row m-0">
         <div class="col-12 mb-1">
          <div class="progress" style="height: 2px;">
            <div class="progress-bar" :class="{'bg-success': percentageStorage < 60, 'bg-warning': percentageStorage >= 60 && percentageStorage < 80, 'bg-danger': percentageStorage >= 80 }" role="progressbar" :style="'width:' + percentageStorage + '%'" :aria-valuenow="percentageStorage" aria-valuemin="0" aria-valuemax="100" v-if="percentageStorage <= 100"></div>
            <div class="progress-bar bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100%" aria-valuemin="0" aria-valuemax="100" v-else></div>
          </div>
        </div>
        <div class="col-12 small">
          {{convertB(totalStorage).amount}} {{convertB(totalStorage).type}} of {{convertB(theUser.subscription.details.storage).amount}} {{convertB(theUser.subscription.details.storage).type}} used
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StorageUsage',
  props: ['storage'],
  computed: {
    ...mapGetters(['theUser', 'storageUsed', 'storageStatus']),
    percentageStorage () {
      var ret = 0
      if (this.storage) {
        ret = (this.storage / this.theUser.subscription.details.storage) * 100
      } else {
        ret = (this.storageUsed / this.theUser.subscription.details.storage) * 100
      }
      return ret
    },
    totalStorage () {
      var ret = 0
      if (this.storage) {
        ret = this.storage
      } else {
        ret = this.storageUsed
      }
      return ret
    }
  },
  methods: {
    convertB (val) {
      var data = {
        amount: 0,
        type: null
      }
      // return Math.round(BtoGB * 100) / 100
      const BtoGB = val / 1000000000
      const BtoMB = val / 1000000
      const BtoKB = val / 1000
      if (val > 999999999) {
        data.amount = Math.round(BtoGB * 100) / 100
        data.type = 'GB'
        return data
      } else if (val > 999999) {
        data.amount = Math.round(BtoMB * 100) / 100
        data.type = 'MB'
        return data
      } else {
        data.amount = Math.round(BtoKB * 100) / 100
        data.type = 'KB'
        return data
      }
    }
  }
}
</script>
<style scoped>
.bg-grey {
  background-color: rgb(222, 226, 230);
}
.overlay {
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 1;
}
</style>
